import React from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import Controls from './Controls';
import { Paper } from '@mui/material';

export default function SelectAutocomplete(props) {

    const { text, options, getOptionLabel, getOptionSelected, isOptionEqualToValue, onChange, onBlur, value, width, disabled,
        required, error = null, helperText = error, border } = props;

    const commonStyles = {
        border: 1
    };

    const CustomPaper = (props) => {
        return <Paper sx={{ ...commonStyles }} elevation={8} {...props} />;
    };

    return (
        <Autocomplete
            style={{ width: width }}
            getOptionLabel={getOptionLabel}
            options={options}
            value={value}
            onChange={onChange}
            PaperComponent={CustomPaper}
            isOptionEqualToValue={isOptionEqualToValue}
            renderInput={(params) =>
                <Controls.Input
                    {...(error && { error: true, helperText: error })}
                    helperText={error ? helperText : ''}
                    {...params}
                    onBlur={onBlur}
                    label={text}
                    variant="outlined"
                    required={required} />
            }
            disabled={disabled}
        />
    )
}
